<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :mini-variant.sync="miniVariant"
      v-model="drawer"
      enable-resize-watcher
      app
      ref="customMenu"
      width="220"
    >
      <v-list>
        <div v-for="(link, i) in menu" :key="i" class="main_menu_item" router
            :item="{ href: { name: link.component }, text: link.title}">
          <v-list-tile
            v-if="link.type === 'link' && link.rights.indexOf($store.state.auth.role) >= 0"
            @click="go(link.component)"
            :class="link.component === $route.name ? 'highlighted' : ''"
            :disabled="!isAdmin && !$store.state.user.package_id && !$services.isAllowedForNonePackage(link.component)"
          >
            <v-list-tile-action>
              <img v-if="link.icon.includes('data:image')" width="22px" :src="link.icon"/>
              <v-icon v-else>{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ link.title }}
                <v-chip v-if="link.count >= 0" class="navigation-title-chip ml-1" label text-color="blue">
                  {{ getCounter(link.component) }}
                </v-chip>
                <v-chip v-if="link.additional" class="navigation-title-chip" label text-color="white" color="orange">
                  {{ link.additional }}
                </v-chip>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="link.type === 'divider'"></v-divider>
          <v-subheader
            v-if="link.type === 'header'"
            :key="link.header"
          >
            {{ link.title }}
          </v-subheader>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="main-toolbar" color="primary" dark fixed app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="toggleMenu()"></v-toolbar-side-icon>
      <img src="@/assets/img/logo/logo-beta.png" @click="$router.push({name: 'Dashboard'})" class="pointer logo ml-3 xs-mx-0">
      <MainSearch :moveSearch="moveSearch"></MainSearch>
      <v-spacer></v-spacer>
      <!-- <v-icon v-if="$store.state.user.is_trial" class="header-info px-3" color="yellow accent-3" @click="showInfo()">error_outline</v-icon> -->
      <!-- <v-tooltip v-if="$store.state.user.is_trial" bottom class="px-3">
        <v-icon class="header-info" color="yellow accent-3" slot="activator">error_outline</v-icon>
        <span style="font-size: 16px;">
          We want to inform you that we start using subscription plans in {{ $moment('03-05-2020').diff($moment(), 'days')}} days.<br/>
        </span>
      </v-tooltip> -->
      <UserMenu></UserMenu>
      <Notifications></Notifications>
      <SendOfferModal></SendOfferModal>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; {{ year }} - Kol-Yom, </span>
      <span class="mr-3 ml-2">Version:
        <v-tooltip top v-if="isAdmin">
          <span slot="activator">{{ $store.state.settings.serverVersions ? $store.state.settings.serverVersions[0].version : ''}}</span>
            <div class="app-version mb-2 pb-2" v-for="(version, index) in $store.state.settings.serverVersions" :key="index">
              <p><b>Version:</b> {{version.version}}</p>
              <p><b>Date:</b> {{version.date}}</p>
              <p><b>Name:</b> {{version.name}}</p>
              <p><b>Changes:</b> <span v-if="Object.entries(version.changes).length === 0 && version.changes.constructor === Object">-</span></p>
              <ul>
                <li v-if="version.changes.features && version.changes.features.length">
                  <p><b>Features:</b></p>
                  <ul>
                    <li v-for="(feature, ind) in version.changes.features" :key="ind">{{feature}}</li>
                  </ul>
                </li>
                <li v-if="version.changes.updates && version.changes.updates.length">
                  <p><b>Updates:</b></p>
                  <ul>
                    <li v-for="(item, ind) in version.changes.updates" :key="ind">{{item}}</li>
                  </ul>
                </li>
                <li v-if="version.changes.fixes && version.changes.fixes.length">
                  <p><b>Fixes:</b></p>
                  <ul>
                    <li v-for="(item, ind) in version.changes.fixes" :key="ind">{{item}}</li>
                  </ul>
                </li>
                <li v-if="version.changes.known_issues && version.changes.known_issues.length">
                  <p><b>Known issues:</b></p>
                  <ul>
                    <li v-for="(item, ind) in version.changes.known_issues" :key="ind">{{item}}</li>
                  </ul>
                </li>
              </ul>
            </div>
          </v-tooltip>
          <span v-else>{{ $store.state.settings.serverVersions ? $store.state.settings.serverVersions[0].version : ''}}</span>
        </span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'ToolbarComponent',
  data () {
    return {
      loading: false,
      isAdmin: this.$store.state.user.permissions.is_admin,
      clipped: true,
      fixed: false,
      drawer: true,
      miniVariant: false,
      year: (new Date()).getFullYear(),
      titleApp: '',
      languages: [],
      sum: 150,
      message: false,
      hints: true,
      moveSearch: true,
      menu: [
        {
          type: 'header',
          title: 'Main Navigation:'
        },
        {
          type: 'link',
          icon: 'dashboard',
          title: 'Dashboard',
          // lang: 'main_menu.crm',
          component: 'Dashboard',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'timeline',
          title: 'Site Insights',
          component: 'SiteInsights',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: require('@/assets/img/xXx.svg'),
          title: '10Club',
          component: 'TenClub',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'icon-bar-chart',
          title: 'Weather',
          // lang: 'main_menu.crm',
          component: 'Weather',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'folder_open',
          title: this.$store.state.user.permissions.is_admin ? 'All Projects' : 'My Projects',
          // lang: 'main_menu.crm',
          component: 'Projects',
          count: true,
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'icon-link',
          title: this.$store.state.user.permissions.is_admin ? 'All Links' : 'My Links',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Links',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'icon-docs',
          title: this.$store.state.user.permissions.is_admin ? 'All Reports' : 'My Reports',
          // additional: 'Beta',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Reports',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'done_all',
          title: this.$store.state.user.permissions.is_admin ? 'All Goals' : 'My Goals',
          count: true,
          component: 'Goals',
          rights: ['admin', 'user', 'dtnt_user']
        },
        {
          type: 'link',
          icon: 'group',
          title: 'Users',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Users',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'language',
          title: 'Proxies',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Proxies',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'list',
          title: 'Categories',
          // lang: 'main_menu.crm',
          component: 'Categories',
          rights: ['admin']
        }
        // {
        //   type: 'link',
        //   icon: 'icon-rocket',
        //   title: 'Scrapers',
        //   additional: 'Beta',
        //   // lang: 'main_menu.crm',
        //   component: 'Scrapers',
        //   rights: ['member', 'admin', 'guest', 'client']
        // }
      ]
    }
  },
  props: {
    source: String
  },
  computed: {
    Projects () {
      return this.$store.state.metadata.totalProjects
    },
    MyProjects () {
      return this.$store.state.user.projects_count
    },
    Links () {
      return this.$store.state.metadata.totalLinks
    },
    Reports () {
      return this.$store.state.metadata.totalReports
    },
    Proxies () {
      return this.$store.state.metadata.totalProxies
    },
    Users () {
      return this.$store.state.metadata.totalUsers
    },
    Goals () {
      return this.$store.state.metadata.totalGoals
    }
  },
  mounted () {
    this.titleApp = this.$store.state.settings.appName
    this.$on('loading', (value) => {
      this.$parent.$emit('loading', value)
    })
  },
  beforeDestroy () {
    this.$off('loading')
  },
  methods: {
    showInfo () {
      let message = `We want to inform you that the trial period is will ended after <b>${this.$moment(this.$store.state.user.package_expired_at).diff(this.$moment(), 'days')}</b> days. Please make sure at the end of the trial period on your account left just needed projects and keywords. When the trial period is over you should choose the package that you want to use inside the system. Please review the subscription plan.`
      this.$eventEmitter.$emit('showAlert', 'perms', 'Thank you for using the Kolyom system', message)
    },
    getCounter (componentName) {
      return this[componentName]
    },
    go (dest) {
      this.$router.push({name: dest})
    },
    changeLang (val) {
      let params = { lang: val }
      this.$router.push({name: this.$router.name, params: params})
    },
    toggleMenu () {
      let menuEl = this.$refs.customMenu
      if (!menuEl.isMobile) {
        this.miniVariant = !this.miniVariant
      } else {
        this.drawer = !this.drawer
      }
      this.moveSearch = !this.moveSearch
    }
  }
}
</script>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolbarComponent.vue